import React from "react";
import {
  IconButtonProps,
  useTheme,
  Tooltip,
  IconButton,
  Badge,
} from "@mui/material";
import { tokens } from "../../theme";

export type CustomIconButtonProps = {
  color?: "primary" | "secondary" | "success" | "error" | "info" | "warning";
  size?: "small" | "medium" | "large";
  variant?: "contained" | "outlined" | "text";
  tooltipPlacement?:
    | "right"
    | "left"
    | "top"
    | "bottom"
    | "bottom-end"
    | "bottom-start"
    | "left-end"
    | "left-start"
    | "right-end"
    | "right-start"
    | "top-end"
    | "top-start";
  tooltipMessage?: string;
  showTooltip?: boolean;
  notifyCount?: number;
} & IconButtonProps;

const CustomIconButton: React.FC<CustomIconButtonProps> = ({
  size,
  color,
  variant,
  tooltipPlacement,
  tooltipMessage,
  showTooltip = true,
  notifyCount,
  sx,
  ...props
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const iconButton = (
    <IconButton
      size={size || "large"}
      color={color || "success"}
      {...props}
      sx={{ borderRadius: 1, border: 1, m: "2px", ...sx }}
    >
      {notifyCount ? (
        <Badge
          badgeContent={notifyCount}
          color="error"
          sx={{
            "& .MuiBadge-badge": {
              fontSize: "0.5rem",
              height: 16,
              minWidth: 16,
            },
          }}
        >
          {props.children}
        </Badge>
      ) : (
        props.children
      )}
    </IconButton>
  );

  return showTooltip && tooltipMessage ? (
    <Tooltip title={tooltipMessage} placement={tooltipPlacement || "bottom"} arrow>
      {iconButton}
    </Tooltip>
  ) : (
    iconButton
  );
};

export default CustomIconButton;
